import React, { useState } from 'react';
import { BottomActionBarV2, AritoFormV2, DialogV2, AritoIcon } from '@/components/custom/erp';
import { searchSchema, WardFormattedData, type SearchFormValues } from '../../schemas';
import { XaPhuong } from '@/types/schemas/xa-phuong.type';
import { FormMode } from '@/types/form';
import Form from './WardForm';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData: XaPhuong | (Partial<WardFormattedData> & { uuid?: string });
  onSubmit?: (data: WardFormattedData) => void;
}

function WardDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit
}: FormDialogProps) {
  const handleSubmit = (data: WardFormattedData) => {
    if (onSubmit) {
      onSubmit(data);
    }
    onClose();
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={initialData as Partial<SearchFormValues>}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<Form mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default WardDialog;
